<template>
<div>
  <div class="sm:w-192 mt-8 w-full relative ">
    <vs-input class="w-full mt-8" v-model="name" :label-placeholder="$t('message.partners.name')"/>
    <vs-input class="w-full mt-8" v-model="tin" :label-placeholder="$t('message.partners.tin')"/>
    <vs-input class="w-full mt-8" v-model="kpp" :label-placeholder="$t('message.partners.kpp')"/>
    <template v-for="(data, index) in propsBank">
      <div v-if="data.bank === false && data.bik === false" :key="index + 'as'">
        <vx-auto-suggest
          :autoFocus="true"
          :data="bankData"
          :searchLimit="5"
          :placeholder="$t('message.partners.bank')"
          inputClassses="w-full"
          class="w-1/3 mr-2 mt-8 inline-block"
          show-action
          show-pinned
          hideGroupTitle
          background-overlay
          @selected="selected($event, index)">

          <template v-slot:banks="{ suggestion }">
            <div class="flex items-end leading-none py-1">
              <div class="mt-1"> {{ suggestion.name }} - {{ suggestion.bik }} </div>
            </div>
          </template>

          <template v-slot:bik="{ suggestion }">
            <div class="flex items-end leading-none py-1">
              <div class="mt-1"> {{ suggestion.name }} - {{ suggestion.bik }} </div>
            </div>
          </template>

          <template v-slot:noResult>
            <div class="hidden"></div>
          </template>

        </vx-auto-suggest>
        <div class="mt-4 inline-block w-1/8">
          <a href="javascript: void(0)" @click="data.bik = data.bank = ''">
            {{ $t('message.payment.manual') }}
          </a>
        </div>
      </div>
      <div v-else :key="index + 'man'">
        <vs-input
          name="bik"
          :label-placeholder="$t('message.partners.bank')"
          v-model="data.bik"
          v-mask="'##########'"
          class="w-1/4 mr-2 mt-8 inline-block"/>
        <vs-input
          name="bank"
          :label-placeholder="$t('message.partners.bank')"
          v-model="data.bank"
          class="w-1/4 mr-2 mt-8 pr-2 inline-block"/>
        <vs-button v-if="data.id" @click="deleteForm(data.id)">{{ $t('message.partners.delete') }}</vs-button>
      </div>
      <vs-input class="w-full mt-8" v-model="data.account" :label-placeholder="$t('message.partners.account')" :key="index + 'acc'"/>
    </template>
    <vs-button color="primary" type="filled" @click="addProps"
               icon="control_point" class="mt-4">
      {{ $t('message.partners.formAddAcc') }}
    </vs-button>
    <vs-textarea :label="$t('message.partners.comment')" class="mt-12" v-model="comment" />
  </div>
  <div class="w-full sm:w-2/3 mt-32">
    <vs-button @click="back()" line-origin="center"
               color="primary" type="flat" class="my-2 mr-2">
      {{ $t('message.partners.formBack') }}
    </vs-button>
    <vs-button @click="confirmForm" line-origin="center" v-if="!data"
               color="primary" type="gradient" class="my-2 mr-2 float-right">
      {{ $t('message.partners.formCreate') }}
    </vs-button>
    <vs-button @click="confirmForm" line-origin="center" v-else
               color="primary" type="gradient" class="my-2 mr-2 float-right">
      {{ $t('message.partners.formEdit') }}
    </vs-button>
  </div>
</div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'InternalForm',
  components: {VxAutoSuggest},
  props: ['data'],
  data: () => ({
    name: '',
    tin: '',
    kpp: '',
    comment: '',
    propsBank: []
  }),
  methods: {
    ...mapActions('utils', ['fetchBanks']),
    ...mapActions('partners',
      ['addPartner', 'addPartnerAccount', 'fetchPartnerAccounts', 'updatePartner', 'updatePartnerAccount', 'deletePartner', 'deletePartnerAccount']),
    back (back) {
      this.$emit('close-form', back || false)
    },
    selected (event, index) {
      if (event.bik) {
        this.propsBank[index].bank = event.bik.name
        this.propsBank[index].bik = event.bik.bik
      } else {
        this.propsBank[index].bank = event.banks.name
        this.propsBank[index].bik = event.banks.bik
      }
    },
    addProps () {
      this.propsBank.push({
        account: '',
        bank: false,
        bik: false
      })
    },
    async deleteForm (id) {
      await this.deletePartnerAccount({
        templateId: this.data.template_tp_id,
        templateAccId: id
      })
      this.back(true)
    },
    async confirmForm () {
      const data = {
        name: this.name,
        tin: this.tin,
        kpp: this.kpp,
        note: this.comment ? this.comment : this.name
      }
      if (this.data) {
        const {id} = await this.updatePartner({
          data,
          templateId: this.data.template_tp_id
        })
        let i = 0
        for (const item of this.propsBank) {
          const data = {
            templateId: id,
            templateAccId: item.id,
            data: {
              template_tp_id: id,
              account_number: item.account,
              bank_name: item.bank,
              bank_bik: item.bik,
              sign_main: i++ === 0 ? 1 : 0
            }
          }
          if (item.old) await this.updatePartnerAccount(data)
          else await this.addPartnerAccount(data)
        }
      } else {
        const {id} = await this.addPartner(data)
        for (const i in this.propsBank) {
          await this.addPartnerAccount({
            templateId: id,
            data: {
              account_number: this.propsBank[i].account,
              bank_name: this.propsBank[i].bank,
              bank_bik: this.propsBank[i].bik,
              sign_main: i === 0 ? 1 : 0
            }
          })
        }
      }
      this.back()
    }
  },
  computed: {
    ...mapGetters('utils', ['banks']),
    ...mapGetters('partners', ['getPartnerAccounts']),
    bankData () {
      const data = {
        bik: {data: this.banks, key: 'bik'},
        banks: {data: this.banks, key: 'name'}
      }
      return data
    }
  },
  async mounted () {
    await this.fetchBanks()
    if (this.data) {
      this.name = this.data.tp_name
      this.tin = this.data.tp_tin
      console.log(JSON.parse(JSON.stringify(this.data)))
      this.comment = this.data.tp_note
      await this.fetchPartnerAccounts(this.data.template_tp_id)
      for (const i in this.getPartnerAccounts) {
        this.propsBank.push({
          id: this.getPartnerAccounts[i].id,
          account: this.getPartnerAccounts[i].account_number,
          bank: this.getPartnerAccounts[i].bank_name,
          bik: this.getPartnerAccounts[i].bank_bik,
          old: true
        })
      }
    } else {
      this.propsBank.push({
        account: '',
        bank: false,
        bik: false
      })
    }
  }
}
</script>

<style>
  .auto-suggest-suggestions-list {
    z-index: 9999 !important;
  }
  .vs-textarea {
    background: white !important;
  }
</style>
